import { render, staticRenderFns } from "./QueryManagement.vue?vue&type=template&id=004da675&"
import script from "./QueryManagement.vue?vue&type=script&lang=ts&setup=true&"
export * from "./QueryManagement.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./QueryManagement.vue?vue&type=style&index=0&id=004da675&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports